import { HttpModel } from '@/Shared/domain'
import type { TpvModel, TpvsRepository, TpvExcelModel } from '@/Store/domain'
import { TpvForm } from '@/Store/ui/hooks'

interface ITpvs {
  getTpvsData: (
    merchantTargetId: number
  ) => Promise<HttpModel<TpvModel[]>>
  addNewTpv: (data: TpvForm) => Promise<HttpModel<boolean>>
  getTpvsDataExcel: (merchantTargetId: number) => Promise<HttpModel<TpvExcelModel>> 
}

export const TpvsContract = (tpvsRepository: TpvsRepository): ITpvs => ({
  getTpvsData: async (
    merchantTargetId: number,
  ): Promise<HttpModel<TpvModel[]>> =>
    await tpvsRepository.GetTpvsData(merchantTargetId),
  addNewTpv: async (data: TpvForm): Promise<HttpModel<boolean>> =>
    await tpvsRepository.AddNewTpv(data),
  getTpvsDataExcel: async (merchantTargetId: number): Promise<HttpModel<TpvExcelModel>> =>
    await tpvsRepository.GetTpvsDataExcel(merchantTargetId),
})
